import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "FirstVideo",
    component: () => import("../components/FirstVideo.vue"),
  },
  {
    path: "/navpage",
    name: "navPage",
    component: () => import("../components/NavPage.vue"),
  },
  {
    path: "/mnavpage",
    name: "mnavPage",
    component: () => import("../components/MnavPage.vue"),
  },
  {
    path: "/videoplay",
    name: "videoPlay",
    component: () => import("../components/VideoPlay.vue"),
  },
  {
    path: "/enterprise",
    name: "enterprise",
    component: () => import("../components/Enterprise2.vue"),
  },
  
  {
    path: "/themeday",
    name: "themeDay",
    component: () => import("../components/ThemeDay.vue"),
  },
  {
    path: "/vr",
    name: "VR",
    component: () => import("../components/VR.vue"),
  },
  {
    path: "/vrlist",
    name: "VRlist",
    component: () => import("../components/VRlist.vue"),
  },
  {
    path: "/mlist",
    name: "MList",
    component: () => import("../components/MList2.vue"),
  },
  {
    path: "/mmlist",
    name: "MmList",
    component: () => import("../components/MList.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
